import { VisionInstanceSchema } from "../types/visionInstance.js";
export const visionLocalhost = VisionInstanceSchema.parse({
    id: "14a89516-d194-49df-bf62-35ed4c2dd936",
    name: "Vision Localhost",
    inboundApiKey: "vision-localhost-api-key",
    apiUrl: "http://localhost:4001",
    outboundApiKey: "aspire-localhost-api-key",
    shareCodePrefix: "L",
});
export const visionTesting = VisionInstanceSchema.parse({
    id: "a77ed4d4-cd8f-4b05-b393-bf689fa95026",
    name: "Vision Testing",
    inboundApiKey: "vision-docker-api-key",
    apiUrl: "http://vision-api.local.thalamosapp.co.uk:4001",
    outboundApiKey: "aspire-docker-api-key",
    shareCodePrefix: "K",
});
export const defaultVisionInstances = [
    visionLocalhost,
    visionTesting,
];
//# sourceMappingURL=visionInstances.js.map